import { useRouter } from 'next/router';
import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';

const ErrorHandler = ({ isError, message }: { isError: boolean; message?: string }) => {
  const router = useRouter();

  useEffect(() => {
    if (isError) {
      Sentry.captureException(new Error(message || 'custom-travel error'));
      router.push('/custom-travel/error');
    }
  }, [router, isError]);

  return null;
};

export default ErrorHandler;
